module.exports = __webpack_public_path__ + "img/Don.de607f0.png";